import { resetSession, clear401Modal } from "@/redux/auth";
import { useAppDispatch, useAppSelector } from "@/redux/hook";

import ErrorSuccessModal from "@/components/commons/ErrorSuccessModal/ErrorSuccessModal";

const GlobalSessionExpiredModal = () => {
  const dispatch = useAppDispatch();
  const show401Modal = useAppSelector((state) => state.auth.show401Modal);

  const handleLogout = () => {
    dispatch(resetSession());
    dispatch(clear401Modal());
    dispatch({ type: "USER_LOGOUT" });
  };

  if (!show401Modal) {
    return null;
  }

  return (
    <ErrorSuccessModal
      type="error"
      isOpen={show401Modal}
      title="Error"
      message="Session Expired. Please Login Again!"
      buttonText="Logout"
      onPress={handleLogout}
      statusCode={401}
    />
  );
};

export default GlobalSessionExpiredModal;
